module.exports = __webpack_public_path__ + "fonts/Inter-Italic.9528384.woff2";